import { render, staticRenderFns } from "./BackupKey.vue?vue&type=template&id=4d0d7f50&scoped=true"
import script from "./BackupKey.vue?vue&type=script&lang=js"
export * from "./BackupKey.vue?vue&type=script&lang=js"
import style0 from "./BackupKey.vue?vue&type=style&index=0&id=4d0d7f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d7f50",
  null
  
)

export default component.exports